import { createContext } from "react";

export const AgenticAiAvailabilityContext = createContext<boolean>(false);
